// contains common data used throught the whole listing page
import { createAction, createReducer } from '@reduxjs/toolkit';
import Configuration from '../../../configuration';


// 1. Initial state
const initialState = {
  xhrStatus: {
    // it's true when data for a new page are gathering, so it's true the most of listing page GUI is disabled
    pendingProductsRequest: false,

    // if gathering data for a new page finishes with error, this property contains error message
    productsRequestErrorMessage: null,

    // this contains IDs of filters which change triggered gathering data for new page
    // it's mainly used for Loaders components in Filters Panel
    filtersIdsTriggeredProductsRequest: []
  },
  // selected view (grid or list) by user for all listing pages
  // if null a default view is used for each listing page based on UCMS settings
  selectedUserView: null,

  // id of product for which flexible credit tooltip popup is opened on the page
  // if null, no flexible tooltip is opened
  flexibleCreditTooltipProductID: null,

  // id of product for which brief description panel is opened on the page
  // if null, no brief description panel is opened
  briefDescriptionProductID: null,

  // id of product for which Email Me Back Form is opened on the page
  // if null, no Email Me Back Form is opened
  emailWhenBackFormProductID: null,

  // Response of Email Me Back request, it is used for showing a UI message that the Form was submitted successfully
  emailWhenBackXhrResponseContent: null,

  usingFallbackSearchLabsURL: false
};


// 2. Basic actions creators
export const setSelectedUserView = createAction('listingPage/commonData/setSelectedUserView');
export const setPendingProductsRequestAndErrorMessage =
  createAction('listingPage/commonData/setPendingProductsRequestAndErrorMessage');
export const setFiltersIdsTriggeredProductsRequest =
  createAction('listingPage/commonData/setFiltersIdsTriggeredProductsRequest');
export const showFlexibleCreditTooltip = createAction('listingPage/commonData/showFlexibleCreditTooltip');
export const showBriefProductDescription = createAction('listingPage/commonData/showBriefProductDescription');
export const setEmailMeBackProductID = createAction('listingPage/commonData/setEmailMeBackProductID');
export const setEmailMeBackXhrResponse = createAction('listingPage/commonData/setEmailMeBackXhrResponse');
export const setUsingFallbackSearchLabsURL = createAction('listingPage/commonData/setUsingFallbackSearchLabsURL');


// 3. Complex actions which call basic actions above
export function hideFlexibleCreditTooltip() {
  return (dispatch, getState) => {
    if (getState().listingPage.commonData.flexibleCreditTooltipProductID !== null) {
      dispatch(showFlexibleCreditTooltip(null));
    }
  };
}

export function hideBriefProductDescription() {
  return (dispatch, getState) => {
    if (getState().listingPage.commonData.briefDescriptionProductID !== null) {
      dispatch(showBriefProductDescription(null));
    }
  };
}

export function postEmailMeBackForm(params) {
  return (dispatch) => {
    const xhrBody = Object.entries({
      sFUPID: params.productID,
      action: 'subscribeOOS',
      title_id: params.titleId,
      first_name: params.name,
      last_name: params.surname,
      email: params.email
    }).map((val) => `${val[0]}=${val[1]}`).join('&');

    const url = Configuration.get('api.listingPage.emailMeBack');

    fetch(url, {
      method: 'post',
      async: true,
      crossDomain: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: xhrBody
    }).then((data) => data.json()).then((response) => {
      if (response.result === 'OK') {
        dispatch(setEmailMeBackXhrResponse(response.content));
      }
    }).catch(() => {
      dispatch(setEmailMeBackXhrResponse(null));
    });
  };
}

// 4. Reducer
/* eslint-disable no-param-reassign */
export default createReducer(initialState, {
  [setSelectedUserView]: (stateDraft, action) => {
    stateDraft.selectedUserView = action.payload;
  },
  [setPendingProductsRequestAndErrorMessage]: (stateDraft, action) => {
    stateDraft.xhrStatus.pendingProductsRequest = action.payload.isPending;
    stateDraft.xhrStatus.productsRequestErrorMessage = action.payload.errorMessage;
  },
  [setFiltersIdsTriggeredProductsRequest]: (stateDraft, action) => {
    stateDraft.xhrStatus.filtersIdsTriggeredProductsRequest = action.payload;
  },
  [showFlexibleCreditTooltip]: (stateDraft, action) => {
    stateDraft.flexibleCreditTooltipProductID = action.payload;
  },
  [showBriefProductDescription]: (stateDraft, action) => {
    stateDraft.briefDescriptionProductID = action.payload;
  },
  [setEmailMeBackProductID]: (stateDraft, action) => {
    stateDraft.emailWhenBackFormProductID = action.payload;
  },
  [setEmailMeBackXhrResponse]: (stateDraft, action) => {
    stateDraft.emailWhenBackXhrResponseContent = action.payload;
  },
  [setUsingFallbackSearchLabsURL]: (stateDraft, action) => {
    stateDraft.usingFallbackSearchLabsURL = action.payload;
  }
});
